var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',[_c('item-list',{attrs:{"title":_vm.selectedItemsHeader,"rights":_vm.selectedItems},on:{"on-row-clicked":_vm.unselect}})],1),_vm._v(" "),_c('b-col',[_c('item-list',{attrs:{"title":_vm.unselectedItemsHeader,"rights":_vm.availableItems},on:{"on-row-clicked":_vm.select}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }